import { takeLatest, all, delay, put } from 'redux-saga/effects'

import { receiveReducer } from '../cns-util/reducer'

export const HIGHLIGHT_SEARCH_HEADER = 'search/HIGHLIGHT_SEARCH_HEADER'

export function highlightSearchHeader(value) {
  return {
    type: HIGHLIGHT_SEARCH_HEADER,
    value,
  }
}

function* highlightSearchHeaderSaga(action) {
  const { value } = action

  if (!value) {
    return
  }

  yield delay(2000) // 2 seconds delay

  yield put(highlightSearchHeader(false))
}

function* watchHighlightSearchHeader() {
  yield takeLatest(HIGHLIGHT_SEARCH_HEADER, highlightSearchHeaderSaga)
}

export function* rootSaga() {
  yield all([watchHighlightSearchHeader()])
}

const initialState = {
  search: {},
}

export function reducer(state = initialState, action) {
  switch (action.type) {
    case HIGHLIGHT_SEARCH_HEADER: {
      return receiveReducer(state, action, () => ({
        highlightSearchHeader: action.value,
      }))
    }

    default:
      return state
  }
}
